// features/premium/panels/FreeTierPanel.tsx — rail for the free-tier view.
import styled from 'styled-components';
import { Panel, SectionLabel, MetaRow } from '@/ui';
import { usePremium } from '@/hooks';

const Note = styled.p`margin: 0 0 12px; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;
const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px;`;
const Item = styled.li`font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary}; & b { color: ${({ theme }) => theme.color.textPrimary}; }`;

export function FreeTierPanel() {
  const { tiers } = usePremium();
  return (
    <Panel>
      <SectionLabel as="h2">Free Tier</SectionLabel>
      <Note>You are currently on the standard plan.</Note>
      <List>
        {tiers.map((t) => (
          <Item key={t.id}>
            <MetaRow>
              <b>{t.name}</b>
              <span>{t.tagline}. {t.audience}</span>
            </MetaRow>
          </Item>
        ))}
      </List>
    </Panel>
  );
}
